<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body mb-0 pb-0">
                <div v-if="status.list">
                    <div class="row flex-nowrap align-items-center">
                        <div class="col">
                            <TabNavigation
                                v-model="activeTab"
                                :tabs="tabs"
                                class="mb-2"
                                @input="changeTab"
                            />
                        </div>
                        <div class="col-auto">
                            <b-dropdown
                                variant="info"
                                no-caret
                                right
                                class="my-1"
                            >
                                <template #button-content>
                                    <i class="mdi mdi-plus"></i>
                                </template>
                                <b-dropdown-item @click="$refs.candidateListing.openForm()">
                                    <i class="mdi mdi-plus mr-2"></i>
                                    {{ $t('label.createX', []) }}
                                </b-dropdown-item>
                                <b-dropdown-item @click="formLink()">
                                    <i class="mdi mdi-file-import mr-2"></i>
                                    Form
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center m-5 p-5">
                    <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                </div>
                <CandidateListing
                    v-if="showListing"
                    ref="candidateListing"
                    :candidateStatus="activeTab"
                    class="fade-in"
                    @done="getCandidateStatusList(searchCriteria)"
                />
            </div>
        </div>
    </Layout>
</template>
<script>
import TabNavigation from "@/components/customTopNav";
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { SESSION } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { candidateStatusMethods } from "@/state/api";
import { CANDIDATE_STATUS_MODULE } from "@/state/api/candidateStatus.state";
import CandidateListing from "@/views/pages/admin/candidate/candidateListing";

export default {
    page: {
        title: i18n.t("module.candidate"),
    },
    components: { Layout, PageHeader, CandidateListing, TabNavigation },
    created() {
        sessionHelper.clearSearch(SESSION.CANDIDATE_STATUS_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            title: i18n.t("module.candidate"),
            items: [
                {
                    text: i18n.t("module.recruitment"),
                    href: '/recruitments',
                },
                {
                    text: i18n.t("module.candidate"),
                    active: true,
                },
            ],
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            tabs: [],
            activeTab: null,
            showListing: false,
        };
    },
    methods: {
        ...candidateStatusMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.CANDIDATE_STATUS_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.CANDIDATE_STATUS_SEARCH);
            }
            if(isDefault) {
                this.searchCriteria = {
                    showNa: 1, // show N/A status
                    isActive: this.isActive.value,
                };
            }
            this.getCandidateStatusList(this.searchCriteria);
        },
        getCandidateStatusList(filter) {
            this.getAllCandidateStatus({filter})
                .then((result) => {
                    if (result?.success) {
                        this.tabs = this.tableRows.map((item) => ({
                            id: item.uuid,
                            name: item.name,
                            count: item.candidateCount,
                        }));
                        this.activeTab = this.tabs.find((item) => item.id == this.activeTab)?.id || this.tabs[0]?.id;
                        this.showListing = true;
                    }
                });
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.CANDIDATE_STATUS_SEARCH, filter);
        },
        changeTab() {
            this.showListing = false;
            this.$nextTick(() => {
                this.showListing = true;
            });
        },
        formLink() {
            const route = this.$router.resolve({ name: 'CandidateApplication' });
            const url = new URL(route.href, window.location.origin).href;
            // navigator.clipboard.writeText(url);
            // alertHelper.alertInfo({message: 'Copied!'});
            window.open(url, '_blank');
        },
    },
    computed: {
        ...mapState(CANDIDATE_STATUS_MODULE, ['status']),
        tableRows() {
            return this.$store.state.api.candidateStatus.list.data || [];
        },
    },
}
</script>
